// Stepts for homepage
const onboardingSiteSteps = [
{
        element: ".main-headline",
        popover: {
            title: '🙋<br>Začíname',
            description: '<b>Toto je onboarding stránka,</b> ktorá pomáha nalodiť talenty do firmy.',
            position: 'bottom-left',
            showButtons: true,         // Do not show control buttons in footer
        },
},
{
    element: ".timeline-wrapper",
    popover: {
        title: '🥳<br>Timeline',
        description: 'Každá fáza náboru má vlastnú stránku, prepínať medzi nimi môžeš tu. V červenom kruhu <div class="badge badge-timeline-red"><span>1</span></div> vidíš počet zamestnancov, ktorí práve prechádzajú danou fázou náboru.',
        position: 'bottom-center',
        showButtons: true,
    },
},
{
    element: ".medium-editor",
    popover: {
        title: ' ',
        description: 'Obsah stránky je možné editovať kliknutím priamo do textu ako vo Worde.',
        position: 'bottom-center',
        showButtons: true,
    },
},
{
    element: ".footer-bottom-fixed",
    popover: {
        title: '🥳 <br>Hotovo!',
        description: '<b>Nezabudni, že do sprievodcu sa môžeš kedykoľvek vrátiť</b> kliknutím na ikonu lode Onboardio vľavo dole.<br>',
        position: 'top-right',
        showButtons: true,         // Do not show control buttons in footer
        nextBtnText: 'Rozumiem',
        doneBtnText: 'Rozumiem',        // Next button text for this step
    },
},
]



export default onboardingSiteSteps